module.exports = __webpack_public_path__ + "img/14_34.2d0de9e3.png";